import React from 'react';

export interface SwatchProps {
    color?: string;
    size?: number;
    on?: boolean;
    radius?: number;
    children?: React.ReactNode;
    onClick?: () => void;
    'aria-label'?: string;
    'aria-pressed'?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const BASE_CLASSES =
    'inline-flex items-center justify-center flex-none transition-opacity duration-150 p-0';
const OUTLINED_CLASSES =
    'border-[1.5px] border-solid border-[var(--malachite-card-border)] bg-transparent';
const FILLED_CLASSES = 'border-0';

const Swatch: React.FC<SwatchProps> = ({
    color,
    size = 14,
    on = true,
    radius = 3,
    children,
    onClick,
    'aria-label': ariaLabel,
    'aria-pressed': ariaPressed,
    className = '',
    style = {},
}) => {
    const isOutlined = !color;

    const classes = [
        BASE_CLASSES,
        isOutlined ? OUTLINED_CLASSES : FILLED_CLASSES,
        onClick ? 'cursor-pointer' : 'cursor-default',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    const dynamicStyle: React.CSSProperties = {
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${radius}px`,
        opacity: on ? 1 : 0.3,
        ...(color && { background: color }),
        ...style,
    };

    if (onClick) {
        return (
            <button
                type="button"
                onClick={onClick}
                aria-label={ariaLabel}
                aria-pressed={ariaPressed ?? on}
                className={classes}
                style={dynamicStyle}
            >
                {children}
            </button>
        );
    }

    return (
        <span className={classes} style={dynamicStyle} aria-label={ariaLabel}>
            {children}
        </span>
    );
};

export default Swatch;
export { Swatch };
